import React, { useEffect } from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';

const RulesComponent = ({ setScreenNumber, onQuestionClick }) => {
  useEffect(() => {
    const root = document.getElementById('root');
    if (root) root.scrollTop = 0;
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={styles.container}>
      <img
        src={getImageFromS3('/images/mgm/bg.png')}
        alt="background"
        className={styles.backgroundImage}
      />
      <div className={styles.content}>
        <div className={styles.header}>
          <svg
            width="20"
            height="18"
            viewBox="0 0 20 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={() => setScreenNumber(1)}
          >
            <path
              d="M4.29675 8.59375L9.66769 13.9647C10.261 14.5579 10.261 15.5198 9.66769 16.1131C9.07444 16.7063 8.11258 16.7063 7.51932 16.1131L0.707108 9.30086C0.316583 8.91033 0.316583 8.27717 0.707107 7.88664L7.51932 1.07443C8.11258 0.481175 9.07444 0.481175 9.66769 1.07443C10.261 1.66769 10.261 2.62955 9.66769 3.22281L4.29675 8.59375Z"
              fill="white"
            />
            <rect
              x="2.78076"
              y="6.99902"
              width="17"
              height="3"
              rx="1.5"
              fill="white"
            />
          </svg>
          <div onClick={onQuestionClick}>
            Є питання?
            <svg
              width="27"
              height="21"
              viewBox="0 0 27 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.86207 0C0.837931 0 0 0.821739 0 1.82609V16.4348L2.7931 13.6957H20.4828C21.5069 13.6957 22.3448 12.8739 22.3448 11.8696V1.82609C22.3448 0.821739 21.5069 0 20.4828 0H1.86207ZM23.2759 7.30435V11.8696C23.2759 13.4217 22.0655 14.6087 20.4828 14.6087H13.0345V16.4348C13.0345 17.4391 13.8724 18.2609 14.8966 18.2609H24.2069L27 21V9.13043C27 8.12609 26.1621 7.30435 25.1379 7.30435H23.2759Z"
                fill="white"
              />
            </svg>
          </div>
        </div>
        <h1>Правила програми</h1>
        <h2 style={{ marginTop: 30 }}>1. Загальні умови</h2>
        <ul>
          <li>
            Участь у програмі можуть брати працівники дистриб’юторських
            компаній: DL SOLUTION.
          </li>
          <li>
            Учасник повинен бути належним чином зареєстрований у програмі та
            ідентифікований як партнер.
          </li>
          <li>
            Програма спрямована на проходження опитувальника повнолітніми
            курцями.
          </li>
          <li>
            Учасники програми не перебувають у трудових відносинах з
            організатором, на них не поширюються внутрішній трудовий розпорядок,
            трудові правила організатора.
          </li>
          <li>
            Учасники програми не є представниками організатора, не перебувають у
            відносинах представництва з ним.
          </li>
          <li>
            Учасники виконують умови програми на власний розсуд у визначений
            ними час, у визначеному ними місці.
          </li>
          <li>
            Учасники отримують бали та розпоряджаються ними на власний розсуд у
            визначеному ними розмірі в межах установленого програмою ліміту.
          </li>
        </ul>
        <h2 style={{ marginTop: 40 }}>2. Умови залучення користувачів</h2>
        <ul>
          <li>
            Залучення користувачів здійснюється через особистий кабінет
            учасника.
          </li>
          <li>Учасник генерує унікальний QR-код або персональне посилання.</li>
          <li>Повнолітній курець:</li>
          <ul style={{ paddingLeft: 25 }}>
            <li>сканує QR-код та переходить за посиланням;</li>
            <li>проходить перевірку віку;</li>
            <li>заповнює опитувальник на веб-сторінці;</li>
            <li>підтверджує номер телефону;</li>
            <li>отримує поповнення мобільного рахунку у розмірі 30 грн.</li>
          </ul>
          <li>
            Учасник зобов’язаний залучати виключно повнолітніх курців (18+).
          </li>
          <li>
            Дані користувача мають бути повними, достовірними та коректними.
          </li>
        </ul>
        <h2 style={{ marginTop: 40 }}>3. Нарахування балів</h2>
        <ul>
          <li>Бали нараховуються за виконання усіх умов:</li>
          <ul style={{ paddingLeft: 25 }}>
            <li>
              успішне завершення опитувальника повнолітнім курцем із
              підтвердженням номера телефону;
            </li>
            <li>унікальний контакт (без дублювання даних);</li>
            <li>користувач раніше не проходив опитування.</li>
          </ul>
          <li>
            Один повнолітній курець може бути зарахований лише одному учаснику
            програми.
          </li>
          <li>
            Компанія залишає за собою право здійснювати перевірку достовірності
            та валідності даних.
          </li>
        </ul>
        <h2 style={{ marginTop: 40 }}>4. Обмеження та заборони</h2>
        <b>Забороняється:</b>
        <ul style={{ paddingLeft: 80 }}>
          <li>самостійне проходження опитувальника (self-registration);</li>
          <li>створення дублікатів або множинних записів;</li>
          <li>надання неправдивих, неточних або фіктивних даних;</li>
          <li>проходження опитування за інших осіб без їх згоди.</li>
        </ul>
        <b>У разі виявлення порушень:</b>
        <ul style={{ paddingLeft: 80 }}>
          <li>відповідна кількість балів не нараховується або анулюється;</li>
          <li>учасник може бути виключений із програми без попередження.</li>
        </ul>
        <h2 style={{ marginTop: 40 }}>5. Контроль якості</h2>
        <ul>
          <li>
            Усі залучені контакти проходять перевірку на відповідність умовам
            програми.
          </li>
          <li>Компанія має право:</li>
          <ul style={{ paddingLeft: 25 }}>
            <li>
              відхиляти контакти, що не відповідають вимогам або викликають
              сумнів;
            </li>
            <li>
              здійснювати додаткові перевірки, включаючи технічний та
              аналітичний контроль.
            </li>
          </ul>
        </ul>
        <h2 style={{ marginTop: 40 }}>6. Відповідальність</h2>
        <ul>
          <li>Учасник несе відповідальність за:</li>
          <ul style={{ paddingLeft: 25 }}>
            <li>
              залучення виключно повнолітніх курців на підставі їх вільної
              згоди;
            </li>
            <li>дотримання умов та правил програми.</li>
          </ul>
          <li>
            Участь у програмі підтверджує повну та безумовну згоду з цими
            умовами.
          </li>
        </ul>
        <h2 style={{ marginTop: 40 }}>7. Інші умови</h2>
        <ul>
          <li>Компанія залишає за собою право в будь-який час:</li>
          <ul style={{ paddingLeft: 25 }}>
            <li>змінювати умови програми;</li>
            <li>
              призупиняти або припиняти програму без попереднього повідомлення.
            </li>
          </ul>
        </ul>
        <h2 style={{ marginTop: 40 }}>8. Строк дії програми</h2>
        <ul>
          <li>
            Нарахування балів у межах програми здійснюється до 01.12.2026
            включно.
          </li>
          <li>
            Обмін накопичених балів на сертифікати можливий до 01.04.2027
            включно. Після зазначеної дати невикористані бали анулюються.
          </li>
          <li>
            Компанія залишає за собою право змінити строк дії програми або
            завершити її достроково.
          </li>
        </ul>
        <h2 style={{ marginTop: 40 }}>
          9. Умови нарахування балів та отримання винагороди
        </h2>
        <ul>
          <li>За кожного повнолітнього курця учаснику нараховується:</li>
          <ul style={{ paddingLeft: 25 }}>
            <li>50 балів (еквівалент 50 грн).</li>
          </ul>
          <li>Обмін балів можливий за умов:</li>
          <ul style={{ paddingLeft: 25 }}>
            <li>максимальна сума обміну — до 2100 грн на місяць;</li>
            <li>
              обмін здійснюється виключно на сертифікати, доступні в межах
              особистого кабінету, за номером телефону, зазначеним учасником
              програми;
            </li>
            <li>
              грошова виплата або інші способи компенсації не передбачені.
            </li>
          </ul>
          <li>Компанія залишає за собою право:</li>
          <ul style={{ paddingLeft: 25 }}>
            <li>змінювати перелік доступних сертифікатів;</li>
            <li>встановлювати додаткові обмеження.</li>
          </ul>
        </ul>
        <b style={{ marginTop: 40 }}>Примітка</b>
        <p>
          Програма призначена виключно для повнолітніх курців. Компанія здійснює
          діяльність відповідно до вимог чинного законодавства та принципів
          відповідального маркетингу.
        </p>
        <div className={styles.footer}>
          <button onClick={() => setScreenNumber(2)}>Правила програм</button>
          <button
            onClick={() =>
              window.open(
                'https://www.pmiprivacy.com/ukraine/uk/consumer/',
                '_blank'
              )
            }
          >
            Політика конфіденційності
          </button>
          <button onClick={() => setScreenNumber(10)}>FAQ</button>
          <button onClick={() => setScreenNumber(11)}>
            Параметри застосування файлів cookie
          </button>
        </div>
      </div>
    </div>
  );
};

export default RulesComponent;
